import styled from 'styled-components';
import ArrowRightV2 from 'svg/ArrowRightV2';
import ChevronRight from 'svg/ChevronRight';
import { PlayerDiscoverCardProps } from 'screens/PlayerLoggedInScreen/props';
import Link from 'components/Link';

const ImageWrapper = styled.div<{ image: string }>`
  background: ${({ image }) =>
    `linear-gradient(to bottom, rgba(0, 0, 0, 0), #000), url(${image}) lightgray 50% / cover no-repeat`};
`;

const PlayerDiscoverCard: React.FC<PlayerDiscoverCardProps> = ({ image, title, href, icon }) => {
  return (
    <div>
      <Link href={href} className="relative block max-sm:hidden">
        <ImageWrapper
          image={`/images/player-home-v2/logged-in/${image}`}
          className="flex  h-[8.75rem] w-full rounded-3xl "
        >
          <span className="typography-product-subheading m-auto text-center text-color-text-lightmode-invert dark:text-color-text-darkmode-invert">
            {title}
          </span>
        </ImageWrapper>
        <div className="absolute bottom-0 left-1/2 flex h-16 w-16 -translate-x-1/2 translate-y-1/2  cursor-pointer items-center justify-center rounded-full bg-color-brand-primary   shadow-[0px_8px_24px_0px_rgba(0,0,0,0.25)]">
          {icon}
        </div>
      </Link>
      <Link href={href} className="sm:hidden">
        <ImageWrapper
          image={`/images/player-home-v2/logged-in/${image}`}
          className="flex h-[5.25rem] items-center justify-between rounded-xl p-ds-xl "
        >
          <div className="flex items-center gap-ds-lg">
            <div className="flex h-9 w-9  cursor-pointer items-center justify-center rounded-full bg-color-brand-primary   shadow-[0px_8px_24px_0px_rgba(0,0,0,0.25)]">
              {icon}
            </div>
            <span className="typography-product-subheading  text-color-text-lightmode-invert dark:text-color-text-darkmode-invert">
              {title}
            </span>
          </div>
          <ArrowRightV2 className="h-5 w-5 text-color-text-lightmode-invert dark:text-color-text-darkmode-invert" />
        </ImageWrapper>
      </Link>
    </div>
  );
};

export default PlayerDiscoverCard;
